import React, { Component, useState, useEffect } from 'react';

import './styles/App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { ConfigProvider } from './contexts/ConfigContext.js';
import { LeagueDataProvider } from './contexts/LeagueDataContext.js';
import NavBarMini from './components/NavBarMini.js';

import Homepage from './components/Homepage.js';
import HomepageUpdated from './components/HomepageUpdated.js';

import Article from './components/Article.js';
import Account from './components/Account.js';
import Login from './components/Login.js';
import Admin from './components/Admin.js';
import AdminDraft from './components/AdminDraft.js';
import AdminPlayers from './components/AdminPlayers.js';
import AdminGames from './components/AdminGames.js';
import AdminSeasons from './components/AdminSeasons.js';
import AdminSeasonTeams from './components/AdminSeasonTeams.js';
import AdminSeasonGames from './components/AdminSeasonGames.js';
import AdminSeasonPlayoffs from './components/AdminSeasonPlayoffs.js';
import AdminTeams from './components/AdminTeams.js';
import AdminTeamsNew from './components/AdminTeamsNew.js';
import AdminSignedUpPlayers from './components/AdminSignedUpPlayers.js';
import AdminConfig from './components/AdminConfig.js';
import AdminTools from './components/AdminTools.js';
import AdminAwards from './components/AdminAwards.js';
import NotFound from './components/NotFound.js';
import SignUp from './components/SignUp.js';
import Players from './components/Players.js';

import NewPlayer from './components/NewPlayer.js';
import ReturningPlayer from './components/ReturningPlayer.js';
import SignedUpPlayers from './components/SignedUpPlayers.js';

import Game from './components/Game.js';
import OurStory from './components/OurStory.js';
import PlayFor from './components/PlayFor.js';
import Records from './components/Records.js';
import Stats from './components/Stats.js';
import Team from './components/Team.js';
import Teams from './components/Teams.js';
import Schedule from './components/Schedule.js'
import Draft from './components/Draft.js'
import Seasons from './components/Seasons.js'
import SouthieTimes from './components/SouthieTimes.js'
import PrayerIntentions from './components/PrayerIntentions.js'
import NewPrayerIntention from './components/NewPrayerIntention.js'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {

  return (
    <Router>
      <ConfigProvider>
      <LeagueDataProvider>
      <div className="App colorPrimary colorPrimaryHover backgroundColor divider navDividerTop navDividerBottom">
        <NavBarMini alwaysShown={true} />

        <Routes>
          <Route exact path="/home" element={<Homepage/>}/>
          <Route exact path="/" element={<HomepageUpdated/>}/>

          <Route exact path="/games/:gameID" element={<Game/>}/>
          <Route exact path="/articles/:articleID" element={<Article/>}/>

          <Route exact path="/signup" element={<SignUp/>}/>
          <Route exact path="/signup/new" element={<NewPlayer/>}/>
          <Route exact path="/signup/returning" element={<ReturningPlayer/>}/>
          <Route exact path="/signup/all" element={<SignedUpPlayers/>}/>
          <Route exact path="/signup/all/:playerID" element={<SignedUpPlayers/>}/>

          <Route exact path="/players/:playerID" element={<Players/>}/>

          <Route exact path="/our-story" element={<OurStory/>}/>

          <Route exact path="/records" element={<Records/>}/>
          <Route exact path="/stats" element={<Stats/>}/>

          <Route exact path="/teams" element={<Teams/>}/>
          <Route exact path="/teams/:teamID" element={<Team/>}/>
          <Route exact path="/teams/:teamID/seasons/:seasonID" element={<Team/>}/>
          <Route exact path="/who-do-you-play-for/:teamID" element={<PlayFor/>}/>

          <Route exact path="/draft" element={<Draft/>}/>
          <Route exact path="/draft/seasons/:seasonID" element={<Draft/>}/>

          <Route exact path="/schedule" element={<Schedule/>}/>
          <Route exact path="/schedule/teams/:teamID" element={<Schedule/>}/>
          <Route exact path="/schedule/seasons/:seasonID" element={<Schedule/>}/>
          <Route exact path="/schedule/seasons/:seasonID/teams/:teamID" element={<Schedule/>}/>
          <Route exact path="/southietimes" element={<SouthieTimes/>}/>

          <Route exact path="/seasons" element={<Seasons/>}/>
          <Route exact path="/seasons/:seasonID" element={<Seasons/>}/>

          <Route exact path="/prayer-intentions" element={<PrayerIntentions/>}/>
          <Route exact path="/prayer-intentions/:prayerID" element={<PrayerIntentions/>}/>
          <Route exact path="/prayer-intentions/new" element={<NewPrayerIntention/>}/>

          <Route exact path="/account" element={<Account/>}/>
          <Route exact path="/login" element={<Login/>}/>
          <Route exact path="/admin" element={<Admin/>}/>
          <Route exact path="/admin/draft" element={<AdminDraft/>}/>
          <Route exact path="/admin/draft/seasons/:seasonID" element={<AdminDraft/>}/>
          
          <Route exact path="/admin/players" element={<AdminPlayers/>}/>
          <Route exact path="/admin/players/:playerID" element={<AdminPlayers/>}/>
          <Route exact path="/admin/games" element={<AdminGames/>}/>
          <Route exact path="/admin/games/:gameID" element={<AdminGames/>}/>
          <Route exact path="/admin/teams/new" element={<AdminTeamsNew/>}/>
          <Route exact path="/admin/teams" element={<AdminTeams/>}/>
          <Route exact path="/admin/teams/:teamID" element={<AdminTeams/>}/>
          <Route exact path="/admin/seasons" element={<AdminSeasons/>}/>
          <Route exact path="/admin/seasons/:season" element={<AdminSeasons/>}/>
          <Route exact path="/admin/seasons/:season/teams/:teamID" element={<AdminSeasonTeams/>}/>
          <Route exact path="/admin/seasons/:season/games" element={<AdminSeasonGames/>}/>
          <Route exact path="/admin/seasons/:season/playoffs" element={<AdminSeasonPlayoffs/>}/>
          <Route exact path="/admin/signups" element={<AdminSignedUpPlayers/>}/>
          <Route exact path="/admin/config" element={<AdminConfig/>}/>
          <Route exact path="/admin/tools" element={<AdminTools/>}/>
          <Route exact path="/admin/awards" element={<AdminAwards/>}/>
          <Route path="*" element={<NotFound/>}/>
        </Routes>

      </div>
      </LeagueDataProvider>
      </ConfigProvider>
    </Router>
  );
}

export default App;
